import isEmpty from 'lodash/isEmpty';

import {User} from 'app_api/me/types';

import {BaseClient} from '../utils/base-client';

class UserDetailsClient extends BaseClient<User> {
  buildEndpoint({projectId, email = null}) {
    return email ? `api/app/projects/${projectId}/users/${email}` : `api/app/me/`;
  }

  buildQueryParams({projectId, includeWorkspaceUsers = false}) {
    return {
      // eslint-disable-next-line
      include_workspace_users: includeWorkspaceUsers,
      // eslint-disable-next-line
      project_id: projectId,
    };
  }

  buildRequestBody(params) {
    const bodyKeys = [`user_bio`];
    const bodyParams = {};
    bodyKeys.forEach((key) => {
      if (key in params) {
        bodyParams[key] = params[key];
      }
    });

    return isEmpty(bodyParams) ? null : JSON.stringify(bodyParams);
  }

  processResponse(response) {
    return response.results;
  }
}

export const userDetailsClient = new UserDetailsClient();
